import WidgetFormula from 'components/Widgets/WidgetFormula';

const CalcTypeField = ({ item, selectItem, setNewSelectItem, disabled }) => {
  return (
    <WidgetFormula
      item={item}
      value={selectItem ?? {}}
      onChange={(val) =>
        setNewSelectItem({
          value: val.result ?? ' ',
          setting: val,
        })
      }
      disabled={disabled}
    />
  );
};

export default CalcTypeField;
